import { render } from "./ai-top-menu-item-app-switcher.vue?vue&type=template&id=b11fccd2&scoped=true"
import script from "./ai-top-menu-item-app-switcher.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-top-menu-item-app-switcher.vue?vue&type=script&setup=true&lang=js"

import "./ai-top-menu-item-app-switcher.vue?vue&type=style&index=0&id=b11fccd2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b11fccd2"],['__file',"src/layouts/main-layout/components/top-menu/ai-top-menu-item-app-switcher.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b11fccd2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b11fccd2', __exports__)) {
    api.reload('b11fccd2', __exports__)
  }
  
  module.hot.accept("./ai-top-menu-item-app-switcher.vue?vue&type=template&id=b11fccd2&scoped=true", () => {
    api.rerender('b11fccd2', render)
  })

}


export default __exports__